import { Injectable, Output, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { HttpClient, HttpHeaders, HttpEventType, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Tickets } from 'src/app/shared/model/tickets/tickets.model';
import { Base } from '../shared/model/core/base.model';
import { UrlConstantes } from '../utilerias/constantes/urlconstantes';
import { Observable } from 'rxjs';
import { ConsultaList } from '../shared/model/core/ConsultaList.model';
import { Area } from 'src/app/shared/model/tickets/area.model';
import { Comentario } from '../shared/model/tickets/comentario.model';
import { Evidencia } from 'src/app/shared/model/tickets/evidencia.model';
import { map } from 'rxjs/operators';
import { Prioridad } from '../shared/model/tickets/prioridad.model';
import { ParamReporteBean } from '../shared/model/tickets/paramreporte.model';
import { Estatus } from '../shared/model/tickets/estatus.model';
import { Puesto } from '../shared/model/empleado/puesto.model';
import { EmpresaLista } from '../shared/model/tickets/empresaLista.model';
import { TipoSolicitud } from '../shared/model/tickets/tipoSolicitud.model';
import { Marcadores } from '../shared/model/tickets/Marcadores';
import { TicketMejora } from '../shared/model/tickets/ticketMejora.model';
import { TicketPerfil } from '../shared/model/tickets/ticketperfil.model';
import { TicketCapacitacion } from "../shared/model/tickets/ticketCapacitacion.model";
import { archivoSinSelloDeError, ResultadoDescarga, sinSelloDeError } from "../shared/http/sello-de-error";
import { Constantes } from "../utilerias/constantes/constantes";

const API_URL = environment.apiUrl;

@Injectable({
  providedIn: "root",
})
export class TicketsService {
  @Output() nuevoTicketEmitter: EventEmitter<any> = new EventEmitter<any>();
  @Output() nuevoComentarioEmitter: EventEmitter<any> = new EventEmitter<any>();
  @Output() actualizacionDetalleEmitter: EventEmitter<any> =
    new EventEmitter<any>();
  constructor(private httpClient: HttpClient) {}

  guardarTicket(tickets: Tickets) {
    return this.httpClient.post<Tickets>(UrlConstantes.guardarTicket, tickets);
  }

  guardarMejoraTicket(mejora: TicketMejora) {
    return this.httpClient.post<TicketMejora>(
      UrlConstantes.guardarTicketMejora,
      mejora
    );
  }

  consultarDetalleMejora(ticket: Tickets) {
    return this.httpClient.post<TicketMejora>(
      UrlConstantes.consultarDetalleMejora,
      ticket
    );
  }

  guardarPerfilTicket(perfil: TicketPerfil) {
    return this.httpClient.post<TicketPerfil>(
      UrlConstantes.guardarTicketPerfil,
      perfil
    );
  }

  guardarCapacitacionTicket(capacitacion: TicketCapacitacion) {
    return this.httpClient.post<TicketCapacitacion>(
      UrlConstantes.guardarTicketCapacitacion,
      capacitacion
    );
  }

  consultarDetallePerfilTicket(id_ticket: number) {
    return this.httpClient.post<TicketPerfil>(
      UrlConstantes.consultarTicketPerfil,
      id_ticket
    );
  }
  consultarDetalleCapacitacionTicket(id_ticket: number) {
    return this.httpClient.post<TicketCapacitacion>(
      UrlConstantes.consultarTicketCapacitacion,
      id_ticket
    );
  }

  consultarArea(url: string) {
    return this.httpClient.post<ConsultaList<Area>>(url, {});
  }

  consultarEmpresa(url: string) {
    return this.httpClient.post<ConsultaList<EmpresaLista>>(url, {});
  }

  consultarAreaPaginacion(req: ConsultaList<Area>) {
    return this.httpClient.post<ConsultaList<Area>>(
      UrlConstantes.consultaAreaPaginacion,
      req
    );
  }
  // consultaticketsDecuparodos(req: ConsultaList<Tickets>) {
  // return this.httpClient.post<ConsultaList<Tickets>>(UrlConstantes.consultaTicketsDepurados, req);
  //}
  /**
   * Va a ir a cinsultar las solicitudes de acuerdo al estatus.
   * @param url
   * @param elemento
   */
  public obtenerTicketsPorEstatus(elemento: any): Observable<any> {
    return this.httpClient.post<any>(
      UrlConstantes.obtenerTicketPorEstatus,
      elemento,
      {
        headers: this.obtenerEncabezados(),
        responseType: "json",
      }
    );
  }
  /**
   * Método que obtiene los encabezados de la petición (pendiente la implementación del token)
   */
  private obtenerEncabezados = function () {
    return new HttpHeaders().set(
      "Content-Type",
      "application/json; charset=utf-8"
    );
  };

  guardarComentario(comentario: Comentario) {
    return this.httpClient.post<Comentario>(
      UrlConstantes.guardarComentario,
      comentario,
      {}
    );
  }

  /**
   * Va a ir a cinsultar las solicitudes de acuerdo al estatus y los filtros que haya colocado el usuario (nombreCorto o fecha).
   * @param url
   * @param elemento
   */
  public obtenerTicketsFiltro(elemento: any): Observable<any> {
    return this.httpClient.post<any>(
      UrlConstantes.obtenerTicketFiltroPaginacion,
      elemento,
      {
        headers: this.obtenerEncabezados(),
        responseType: "json",
      }
    );
  }

  public consultarComentario(comentario: any): Observable<any> {
    return this.httpClient.post<any>(
      UrlConstantes.consultarComentario,
      comentario,
      {}
    );
  }

  editarEstatusDeTicket(elemento: any) {
    return this.httpClient.post<any>(
      UrlConstantes.editar_estatus,
      elemento,
      {}
    );
  }

  guardarImagen(/*evidencia: Evidencia*/) {
    return this.httpClient.post<Base>(
      UrlConstantes.guardarImagen,
      {} /*evidencia*/
    );
  }

  public uploadEvidencia(data: FormData) {
    return this.httpClient
      .post(UrlConstantes.guardarEvidencia, data, {
        reportProgress: true,
        observe: "events",
      })
      .pipe(
        map((event) => {
          switch (event.type) {
            case HttpEventType.UploadProgress:
              const progress = Math.round((100 * event.loaded) / event.total);
              return { status: "progress", message: progress };

            case HttpEventType.Response:
              return event.body;
            default:
              return `Unhandled event: ${event.type}`;
          }
        })
      );
  }

  verImagen(evidencia: Evidencia) {
    return this.httpClient.post(UrlConstantes.consultaEvidencia, evidencia, {
      responseType: "arraybuffer",
    });
  }

  /**
   * El video de una evidencia, por su id (el servidor lo busca en un ticket
   * de la empresa de la sesion). Antes se posteaba a "video.do" relativo,
   * que no existe: el video de tickets nunca llegaba al backend.
   */
  consultaVideoEvidencia(evidencia: Evidencia) {
    return this.httpClient.post(
      UrlConstantes.consultaVideoEviTickets,
      { id_evidencia: evidencia.id_evidencia },
      { responseType: "blob" }
    );
  }

  /**
   * Va a ir a cinsultar las solicitudes de acuerdo al estatus
   * llebando como parametro el usuario logeado.
   * @param url
   * @param elemento
   */
  public obtenerTicketsDelUsuarioPorEstatus(elemento: any): Observable<any> {
    return this.httpClient.post<any>(
      UrlConstantes.obtenerTicketPorEstatusYUsuario,
      elemento,
      {
        headers: this.obtenerEncabezados(),
        responseType: "json",
      }
    );
  }

  /**
   * Va a ir a consultar las solicitudes de acuerdo al estatus y los filtros que haya colocado el usuario (nombreCorto o fecha)
   * llebando como parametro tambien el usuario logueado.
   * @param url
   * @param elemento
   */
  public obtenerTicketsDelUsuarioFiltro(elemento: any): Observable<any> {
    return this.httpClient.post<any>(
      UrlConstantes.obtenerTicketFiltroPorUsuario,
      elemento,
      {
        headers: this.obtenerEncabezados(),
        responseType: "json",
      }
    );
  }
  public obtenerTicketsDelUsuarioFiltroPaginacion(
    elemento: any
  ): Observable<any> {
    return this.httpClient.post<any>(
      UrlConstantes.consultaTicketsPaginacion,
      elemento,
      {
        headers: this.obtenerEncabezados(),
        responseType: "json",
      }
    );
  }

  /**
   * Descarga por id de evidencia. El servidor ya no recibe ni manda la ruta
   * del disco: resuelve la evidencia contra un ticket de la empresa de la
   * sesion y responde 404 si no lo es.
   */
  descargaArchivo(evidencia: Evidencia) {
    return this.httpClient.get(UrlConstantes.descargarEvidenciaTicket, {
      params: {
        idEvidencia: String(evidencia.id_evidencia),
        fileName: evidencia.nombre ?? "",
      },
      responseType: "arraybuffer",
    });
  }

  nuevaSolicitudTicket(ticket) {
    this.nuevoTicketEmitter.emit(ticket);
  }

  nuevoComentario(comentario) {
    this.nuevoComentarioEmitter.emit(comentario);
  }

  nuevoEstatus(ticket) {
    this.actualizacionDetalleEmitter.emit(ticket);
  }

  public consultarDetalle(ticket: any): Observable<any> {
    return this.httpClient.post<any>(
      UrlConstantes.consultarDetalle,
      ticket,
      {}
    );
  }

  consultarPrioridad() {
    return this.httpClient.post<ConsultaList<Prioridad>>(
      UrlConstantes.consultarPrioridad,
      {}
    );
  }
  /**
   * Reporte de tickets en Excel (GET creacionYDescarga.do). El servidor
   * contesta 200 con el xlsx, 204 si no hay tickets con esos filtros y,
   * ante un error de negocio, 200 sin cuerpo con el motivo en los headers.
   * Por eso se pide la respuesta completa: antes se leia solo el blob y
   * cualquier error salia en pantalla como "No hay datos".
   */
  descargarReporte(paramReporteBean: ParamReporteBean): Observable<ResultadoDescarga> {
    const valores: Record<string, string | number | null | undefined> = {
      fechaInicio: paramReporteBean.fechaInicio,
      fechaFin: paramReporteBean.fechaFin,
      id_area: paramReporteBean.id_area,
      id_estatus: paramReporteBean.id_estatus,
      id_empresaSolicitante: paramReporteBean.id_empresaSolicitante,
      nombreArea: paramReporteBean.nombreArea,
      nombreEstatus: paramReporteBean.nombreEstatus,
      nombreEmpresa: paramReporteBean.nombreEmpresa,
    };
    let params = new HttpParams();
    for (const [nombre, valor] of Object.entries(valores)) {
      if (valor !== null && valor !== undefined && `${valor}`.trim() !== "") {
        params = params.set(nombre, `${valor}`);
      }
    }
    return this.httpClient
      .get(UrlConstantes.reportesTickest, {
        params,
        observe: "response",
        responseType: "blob",
      })
      .pipe(archivoSinSelloDeError("No se pudo generar el reporte de tickets."));
  }

  consultarEstatus() {
    return this.httpClient.post<ConsultaList<Estatus>>(
      UrlConstantes.consultarEstatus,
      {}
    );
  }

  consultaticketsDecuparodos(req: ConsultaList<Tickets>) {
    return this.httpClient.post<ConsultaList<Tickets>>(
      UrlConstantes.consultaTicketsDepurados,
      req
    );
  }

  /**
   * Obtiene los totales de los tickets registrados en el sistema
   * @param url
   * @param elemento
   */
  public obtenerticketsGrafica(
    idSolicitante: any,
    idResolutoria: any,
    prioridad: any
  ): Observable<any> {
    const httpParams = new HttpParams()
      .set("idSolicitante", idSolicitante)
      .set("idResolutoria", idResolutoria)
      .set("prioridad", prioridad);
    return this.httpClient.get<any>(
      API_URL + UrlConstantes.OBTENER_RESUMEN_TICKETS,
      {
        headers: this.obtenerEncabezados(),
        params: httpParams,
        responseType: "json",
      }
    );
  }

  public obtenerticketsSolicitante(idEstatus: any): Observable<any> {
    const httpParams = new HttpParams().set("idEstatus", idEstatus);
    return this.httpClient.get<any>(
      API_URL + UrlConstantes.OBTENER_RESUMEN_TICKETS_SOLICITANTE,
      {
        headers: this.obtenerEncabezados(),
        params: httpParams,
        responseType: "json",
      }
    );
  }

  descargarRptSolicitante(): Observable<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/vnd.ms-excel",
      Authorization: btoa("WEB"),
      "X-Requested-With": "XMLHttpRequest",
    });
    return this.httpClient.get(
      API_URL + UrlConstantes.DESCARGAR_RPT_EXCEL_TICKETS,
      {
        headers: headers,
        responseType: "blob",
      }
    );
  }
  guardarArea(area: Area) {
    return this.httpClient.post<Area>(UrlConstantes.guardarArea, area);
  }

  cambiarBanderaTicket(req: any) {
    return this.httpClient.post<any>(
      API_URL + UrlConstantes.MARCAR_VISTO_NOTIFICACION,
      req
    );
  }

  /**
   * Realiza una petición GET enviando los parámetros de paginación y búsqueda
   * @param {string} url - Url del recurso
   * @return {T} Genérico
   */
  public obtenerCollecionPorPagina(
    page: number,
    size: number,
    sort: string,
    search: string
  ): Observable<any> {
    const httpParams = new HttpParams()
      .set("page", String(page))
      .set("size", String(size))
      .set("sort", String(sort))
      .set("search", String(search));
    return this.httpClient.get<any>(
      API_URL + UrlConstantes.OBTENER_NOTIFICACIONES_PG,
      {
        params: httpParams,
        responseType: "json",
      }
    );
  }

  consultarPuestoPorAreaPaginacion(req: ConsultaList<Puesto>) {
    return this.httpClient.post<ConsultaList<Puesto>>(
      UrlConstantes.consultaPuestoPorAreaPaginacion,
      req
    );
  }

  consultaTipoSolicitud(req: ConsultaList<Marcadores>) {
    return this.httpClient.post<ConsultaList<Marcadores>>(
      UrlConstantes.CONSULTATIPOSOLICITUD,
      req
    );
  }
  consultaSolicitante(req: ConsultaList<Marcadores>) {
    return this.httpClient.post<ConsultaList<Marcadores>>(
      UrlConstantes.CONSULTASOLICITANTE,
      req
    );
  }
  consultaAreaSolicitante(req: ConsultaList<Marcadores>) {
    return this.httpClient.post<ConsultaList<Marcadores>>(
      UrlConstantes.CONSULTAAREASOLICITANTE,
      req
    );
  }
  consultaEstatus(req: ConsultaList<Marcadores>) {
    return this.httpClient.post<ConsultaList<Marcadores>>(
      UrlConstantes.CONSULTAESTATUSSOLICITUD,
      req
    );
  }
  consultaTiempoProceso(req: ConsultaList<Marcadores>) {
    return this.httpClient.post<Marcadores>(
      UrlConstantes.CONSULTATIEMPOPROCESO,
      req
    );
  }
  consultaTiempoAtendido(req: ConsultaList<Marcadores>) {
    return this.httpClient.post<Marcadores>(
      UrlConstantes.CONSULTATIEMPOATENDIDO,
      req
    );
  }
  consultaTiempoVoBo(req: ConsultaList<Marcadores>) {
    return this.httpClient.post<Marcadores>(
      UrlConstantes.CONSULTATIEMPOVOBO,
      req
    );
  }
  consultaTiempoCancelado(req: ConsultaList<Marcadores>) {
    return this.httpClient.post<Marcadores>(
      UrlConstantes.CONSULTATIEMPOCANCELADO,
      req
    );
  }

  consultarTipoSolicitud() {
    return this.httpClient.post<ConsultaList<TipoSolicitud>>(
      UrlConstantes.consultarTipoSolicitud,
      {}
    );
  }

  editarTicket(tickets: Tickets) {
    return this.httpClient.post<Tickets>(UrlConstantes.editarTicket, tickets);
  }
  editarPrioridad(area: Prioridad) {
    return this.httpClient.post<Prioridad>(UrlConstantes.editarPrioridad, area);
  }

  /**
   * Una pagina de la vista previa del reporte. param4 trae el total real
   * de tickets; un pCodRetorno distinto de 00000 (o un cuerpo vacio, que
   * es como sale un error inesperado) se convierte en error de rxjs con el
   * motivo del servidor. Se pide la respuesta completa porque el rechazo
   * sin sesion llega como en la descarga: cuerpo vacio y el motivo en los
   * headers (COD_STATUS / MESSAGE).
   */
  getDatosReporteReporte(paramReporteBean: ParamReporteBean): Observable<ConsultaList<Tickets>> {
    return this.httpClient
      .post<ConsultaList<Tickets>>(UrlConstantes.getDatosReporte, paramReporteBean, {
        headers: this.obtenerEncabezados(),
        observe: "response",
        responseType: "json",
      })
      .pipe(
        sinSelloDeError<ConsultaList<Tickets>>("No se pudieron consultar los tickets del reporte."),
        map((respuesta) => {
          if (!respuesta) {
            throw new Error("No se pudieron consultar los tickets del reporte.");
          }
          if (respuesta.pCodRetorno && respuesta.pCodRetorno !== Constantes.EXITO) {
            throw new Error(respuesta.pMensaje || "No se pudieron consultar los tickets del reporte.");
          }
          return respuesta;
        })
      );
  }
}
